import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { StateStoreService } from '../services/state-store/state-store';
import { callerCanViewCustomerAccess } from '../utils/access-views-gate.utils';

/**
 * Guard for the org-settings **Access overview**.
 *
 * The overview describes the grants the caller's own org issues, so it asks the
 * same question as the customer Team-access tab: a manager-class home org and the
 * caller's own `access_grant_write`. It shares that predicate with the sidebar
 * entry, so the nav item and the page cannot disagree. On refusal it returns to
 * Organisation, which needs no capability.
 */
export const accessOverviewGuard: CanActivateFn = () => {
  const state = inject(StateStoreService);
  const router = inject(Router);
  return callerCanViewCustomerAccess(state) ? true : router.createUrlTree(['/organisation']);
};
